import Header from './Header';
export default Header; 